// 申请列表
const AUDIT_TYPE_MAP = {
    1: [
        { title: "工作室基本信息", id: "GZSJIBENXINXI" },
        { title: "工作室团队", id: "GZSTUANDUI" },
        { title: "教研情况", id: "GZSJIAOYANQINGKUANG" },
        { title: "工作室资金预算", id: "GZSZIJINYUSUAN" },
        { title: "工作室资金支出", id: "GZSZIJINZICHU" },
        { title: "科研情况", id: "GZSKEYANQINGKUANG" },
        { title: "活动方案", id: "GZSHUODONGFANGAN" },
        { title: "标志性成果", id: "GZSBIAOZHIXINGCHENGGUO" },
        { title: "思政课程与课程思政大格局", id: "GZSKCZSSZKC" },
        { title: "团队建设", id: "GZSTUANDUIJIANSHE" },
        { title: "思政实践基地", id: "GZSSHIJIANJIDI" },
        { title: "基地实践活动", id: "GZSJIDIHUODONG" },
        { title: "荣誉", id: "GZSRONGYU" },
        { title: "培育品牌", id: "PEIYUPINPAI" },
    ],
    2: [
        { title: "品牌基本信息", id: "PPJIBENXINXI" },
        { title: "品牌团队", id: "PPTUANDUI" },
        { title: "品牌资金预算", id: "PPZHIJINYUSUAN" },
        { title: "品牌资金使用", id: "PPZHIJINSHIYONG" },
        { title: "年度计划", id: "PPNIANDUJIAHUAN" },
        { title: "品牌活动", id: "PPHUODONG" },
        { title: "品牌建设", id: "PPJIANSHE" },
        { title: "思政育人", id: "PPSIZHENGYUREN" },
        { title: "品牌成果", id: "PPCHENGGUO" },
        { title: "品牌宣传", id: "PPXUANCHUAN" },
        { title: "品牌效果", id: "PPXIAOGUO" },
    ],
    3: [
        { title: "思政微课基本信息", id: "WKJIBENXINXI" },
        { title: "团队成员", id: "WKTUANDUI" },
        { title: "补充材料", id: "WKSP" },
    ],
};
// 对比名称
const FIELD_LABELS = {
    1: {
        GZSJIBENXINXI: {
            name: "工作室名称",
            address: "工作室地点",
            foundTime: "建设日期",
            applyYear: "申报年份",
            declarationName: "申报书",
            acreage: "场所面积",
            belongDepartment: "所属部门",
            tsSzgzsKnow: "全校师生对工作室知晓度",
            tsSzgzsSatisfied: "全校师生对工作室服务满意度",
            reportNum: "项目被省级或国家级媒体报道次数",
            conmunicateNum: "省内外同类院校前来交流学习次数",
            letterOfCommitmentName: "校方承诺书",
            studioStatus: '工作室运行状态',
            activityPlanName: "建设方案",
        },
        GZSTUANDUI: {
            teacherName: "教师姓名",
            sex: '性别',
            // birthday:'',
            education: "学历",
            professionalTitle: "职称",
            engagedContent: "从事内容",
            //major: "",
            joinYear: '加入年份',
            izResponse: '是否负责人',
            izDedicated: '是否专岗',
            izPolitical: '是否思政教师',
            szMemberSource: "成员来源",
            izBsxw: '是否取得博士学位',
            bsTime: '获得博士学位时间',
            phone: '联系方式',
            primaryMission: "主要任务",
        },
        GZSJIAOYANQINGKUANG: {
            "year": "年份",
            "num": "次数"
        },
        GZSZIJINYUSUAN: {
            //name: "",
            capitalSource: "资金来源",
            amount: "资金金额(元)",
            vintages: "年份",
        },

        GZSZIJINZICHU: {
            lxSubsudyFundId: "支出资金来源",
            project: "支出项目",
            amount: "支出金额",
            // surplusMoney: 0,
            costYear: '支出年份',
        },
        GZSKEYANQINGKUANG: {
            // title: "",
            //year: "",
            // achievementType: "",
            //num: "",
            type: "类型",
            xmmc: "项目名称/文章名称",
            lxdw: "立项单位/发表期刊",
            lxsj: "立项时间/发表时间",
            jxsj: "结项时间",
            xnjb: "项目级别",
            zzje: '资助金额'
        },
        GZSHUODONGFANGAN: {
            // title: "",
            year: "年份",
            fileName: '建设总结方案',

        },
        GZSBIAOZHIXINGCHENGGUO: {
            title: "成果名称",
            acquireYear: "年份",
            //achievementType: "",
            amount: "数量",
            levelType: "级别",
            //content: "",
            //courseType: "",
            //otherType: "",
        },
        GZSKCZSSZKC: {
            activityYear: "年份",
            szType: "类别",
            num: "数量",
            otherType: "其它类别",
            titleName: "标题名称",
            levelType: "认定级别",
            otherLevelType: "其它认定级别",
            award: "奖项",
            basicMajorCategory: "专业大类",
            basicMajorSubclass: "专业子类",
            basicMajor: "专业",
            cName: "课程名称/赛项名称/案例名称",
            jkType: "类型",
        },
        GZSTUANDUIJIANSHE: {
            title: "大赛名称",
            buildName: '名称',
            acquireYear: "年份",
            // achievementType: "",
            amount: "数量",
            levelType: "级别",
            // content: "",
            // courseType: "",
            otherLevelType: "其他",
            //otherType: '',
            award: '奖项',
            teacherName: '参赛/指导教师姓名',
        },
        GZSSHIJIANJIDI: {
            baseName: "基地名称",
            cooperativeTime: "加入时间",
            baseForm: "基地形式",
            //amount: "",
            //levelType: "",
            baseType: "基地类别",
            //courseType: "",
            // otherLevelType: "",
            // cooperative_time: "",
            company: '合作单位',
            otherCompany: '其他合作单位',
            keyWords: '育人功能关键词',
            //keyWords: '',

        },
        GZSJIDIHUODONG: {
            cooperativeBaseId: "基地",
            acquireYear: "活动年份",
            peopleNum: "参与人数",
            subject: '主题',
            address: '地点',
        },
        GZSRONGYU: {
            honorName: "名称",
            acquireYear: "年份",
            amount: "数量",
        },
        PEIYUPINPAI: {
            //title: "",
            acquireYear: "年度",
            // achievementType: "",
            // amount: "",
            levelType: "级别",
            // content: "",
            // courseType: "",
            // otherLevelType: "",
            // otherType: '',
            brandName: '名称',
        },
        WKJIBENXINXI: {
            name: "思政微课名称",
            foundTime: "创建时间",
            basicMajorCategory: "专业大类",
            basicMajorSubclass: "专业子类",
            basicMajor: "专业",
            course: '所属课程',
            applyYear: "申报年份",
            courseType: "课程类型",
            declarationName: "申报书",
            wkStudyNum: "学习人次",
            levelType: '级别',
        },
        WKTUANDUI: {
            teacherName: "教师姓名",
            sex: "性别",
            birthday: "生日",
            education: "学历",
            professionalTitle: "职称",
            major: "从事专业",
            primaryMission: "主要任务",
            izPolitical: "是否思政老师",
            joinYear: "加入年份",
            izResponse: "是否负责人",
            memberSource: "成员来源",
        },
        WKSP: {
            type: '视频类型',
            fileName: '思政微课视频',
            filePath: '超链接地址',
            ideologicalElement: '思政元素',
        }
    },
    2: {
        PPJIBENXINXI: {
            name: "品牌名称",
            applyYear: "申报年份",
            belongDepartment: "所属部门",
            foundTime: "建设日期",
            brandClassify: "品牌层级",
            brandLabels: '品牌文化',
            weChatPublicAccount: "品牌公众号",
            promotionAddress: "宣传地址",
            brandExposureRate: "品牌熟知率",
            goodRate: "好评率",
            teacherParticipationRate: "教师参与率",
            studentParticipationRate: "学生参与率",
            declarationName: "申报书",
            // 活动方案
            activityPlanName: "活动方案",
            //keyword: "品牌内涵",
            brandConnotation: "品牌内涵",
            // 专业
            basicMajorCategory: "专业大类",
            basicMajorSubclass: "专业子类",
            basicMajor: "专业",
        },
        PPTUANDUI: {
            teacherName: "姓名",
            sex: '性别',
            // birthday:'',
            education: "学历",
            professionalTitle: "职称",
            //major: "",
            primaryMission: "主要任务",
            //izPolitical: "",
            joinYear: '加入年份',
            izResponse: '是否负责人',
            //memberSource: "",
            engagedContent: "从事专业",
            phone: "联系方式",
            departCode: "所属部门",
        },
        PPZHIJINYUSUAN: {
            //name: "",
            capitalSource: "资金来源",
            amount: "资金金额",
            vintages: "年份",
        },
        PPZHIJINSHIYONG: {
            lxSubsudyFundId: "支出资金来源",
            project: "支出项目",
            amount: "支出金额",
            //surplusMoney: 0,
            costYear: "支出年份",
        },
        PPNIANDUJIAHUAN: {
            year: "年份",
            fileName: '年度总结报告'
        },
        PPHUODONG: {
            name: "名称",
            activityYear: "年份",
            type: "类别",
            otherType: "其他类别",
            location: "地点",
            partNum: '人数',
            personTime: '人次',
            content: "活动主题",
            //achievementType: "",
            //amount: "",
            //courseType: "",
            holdingTime: "时间",
        },
        PPJIANSHE: {
            constructionYear: "年份",
            name: "名称",
            type: "类别",
            otherType: '其他类别',
            num: "数量/人次",
            webAddress: '网址',
        },
        PPSIZHENGYUREN: {
            productType: "类型",
            resourceCategory: "名称/类别",
            resourceNum: '数量',
        },
        PPCHENGGUO: {
            achievementName: "名称",
            achievementNum: '数量',
            name: "项目名称/课程名称/成果名称",
            achievementDepart: "立项单位",
            achievementStartTime: '立项时间/认定时间/时间',
            achievementLevel: "项目级别/认定级别/级别",
            achievementEndTime: '结项时间',
            fundingAmount: '资助金额',
        },
        PPXUANCHUAN: {
            publicationNum: "发文数量",
            clickNum: "点击量",
            focusNum: "关注人数",
            smallCourseNum: "微课开发",
            collegesStudentNum: "院校交流学习次数",
            addYear: '年份',
            channelCarrier: '渠道载体',
        },
        PPXIAOGUO: {
            addYear: "年份",
            type: "类别",
            num: "个数/次数",
            award: "名称",
            otherType: "其他类别",
            awardTime: "时间",
            achievementLevel: "级别",
            awardName: "成果名称",
        },
    },
    3: {
        WKJIBENXINXI: {
            name: "思政微课名称",
            foundTime: "创建时间",
            basicMajorCategory: "专业大类",
            basicMajorSubclass: "专业子类",
            basicMajor: "专业",
            course: '所属课程',
            applyYear: "申报年份",
            courseType: "课程类型",
            declarationName: "申报书",
            wkStudyNum: "学习人次",
            levelType: '级别',
            // applyNameId: '所属思政工作室',
        },
        WKTUANDUI: {
            teacherName: "教师姓名",
            sex: '性别',
            birthday: '生日',
            education: "学历",
            professionalTitle: '职称',
            major: '从事专业',
            primaryMission: '主要任务',
            izPolitical: '是否思政老师',
            joinYear: '加入年份',
            izResponse: '是否负责人',
            memberSource: '成员来源',
        },
        WKSP: {
            type: '视频类型',
            fileName: '思政微课视频',
            filePath: '超链接地址',
            ideologicalElement: '思政元素',
        },
    },
};
const AUDIT_STATUS_OPTIONS = [
    { label: "待审核", value: "1" },
    { label: "审核通过", value: "2" },
    { label: "审核未通过", value: "3" },
];

// 状态映射
const STATUS_TEXT_MAP = {
    1: "待审核",
    2: "已通过",
    3: "审核未通过",
    4: '已撤销'
};

const STATUS_CLASS_MAP = {
    1: "audit",
    2: "pass",
    3: "reject",
};

const TYPE_MAP = {
    INSERT: "新增",
    UPDATE: "修改",
    DELETE: "删除",
};
// 审核类型文件查看映射
const FILE_VIEW_MAP = {
    1: {
        GZSJIBENXINXI: {
            'declarationName': {
                urlName: 'declarationPath',
                name: '申报书',
            },
            'letterOfCommitmentName': {
                urlName: 'letterOfCommitmentPath',
                name: '校方承诺书',
            },
            'activityPlanName': {
                urlName: 'activityPlanPath',
                name: '建设方案',
            }
        },

        GZSHUODONGFANGAN: {
            fileName: {
                urlName: 'filePath',
                name: '建设总结方案',
            },
        },

        WKSP: {
            name: {
                urlName: 'name',
                name: '微课视频',
            },
            fileName: {
                urlName: 'filePath',
                name: '微课视频',
            },
        },
        WKJIBENXINXI: {
            declarationName: {
                urlName: 'declarationPath',
                name: '申报书',
            },
        },
    },
    2: {
        PPJIBENXINXI: {
            'declarationName': {
                urlName: 'declarationPath',
                name: '申报书',
            },
            'activityPlanName': {
                urlName: 'activityPlanPath',
                name: '活动方案',
            }
        },
        PPNIANDUJIAHUAN: {
            fileName: {
                urlName: 'filePath',
                name: '年度总结报告',
            },
        }
    },
    3: {
        WKJIBENXINXI: {
            declarationName: {
                urlName: 'declarationPath',
                name: '申报书',
            },
            fileName: {
                urlName: 'filePath',
                name: '微课视频',
            },
        },
        WKSP: {
            name: {
                urlName: 'filePath',
                name: '思政微课视频',
            },
            fileName: {
                urlName: 'filePath',
                name: '思政微课视频',
            },
            filePath: {
                urlName: 'filePath',
                name: '超链接地址',
            },
        },
    },
};
// 小手映射
const CURSOR_POINTER = [
    '申报书',
    '校方承诺书',
    '建设方案',
    '建设总结方案',
    '年度总结报告',
    '微课视频',
    '思政微课视频',
    '超链接地址',
    '活动方案',
];
export {
    AUDIT_TYPE_MAP,
    FIELD_LABELS,
    AUDIT_STATUS_OPTIONS,
    STATUS_TEXT_MAP,
    STATUS_CLASS_MAP,
    TYPE_MAP,
    FILE_VIEW_MAP,
    CURSOR_POINTER
}